import styled from 'styled-components';
export const Container = styled.div`
  border: 3px dashed #4e6e29;
  text-align: center;
  padding: 20px;
  margin: 25px;
  border-radius: 10px;
  transition: all 0.3s ease-in-out;
  height: -webkit-fill-available;

  &:hover {
    border: 3px solid #4e6e29;
  }
  svg {
    font-size: 5rem;
  }
`;
export const ContantService = styled.div`
  padding: 1.25em 0.625em;
  color: rgb(0, 0, 0);
  height: 100%;
  border-radius: 10px;
  transition: all 0.3s ease-in-out;
  &:not(.col-mid):hover {
    background-color: #b0b8a7;
    cursor: pointer;
  }
`;
